import InfiniteScrollList from "../../../../../common/infinite-scroll-list";
import ConfigService from "../../../../../../services/ConfigService";
import MessageService from "../../../../../../services/MessageService";
import MessageListItem from "../message-list-item";
import JWTClient from "../../../../../../services/JWTClient";
import ModuleInfoProvider from "../../../../../../services/ModuleInfoProvider";

export default class MessageInfiniteScrollList extends InfiniteScrollList {
    emptyStateMessage = 'message.list.empty';
    messengerDomain = '';

    constructor(props) {
        super(props);
        this.messengerDomain = ModuleInfoProvider.getModuleWebServiceUrl('messenger');
    }

    componentDidMount() {
        this.getNext();
        MessageService.observable.subscribe(this.getNext);
    }

    componentWillUnmount() {
        MessageService.observable.unsubscribe(this.getNext);
    }

    renderItem = (item) => (<MessageListItem message={item}/>);

    getPrevRequest = () => {
        const domain = this.messengerDomain;
        const list = this.state.list;
        const boundId = list.length ? list[0].id : 0;
        return JWTClient.fetch(domain + '/messages?received=1&draft=0&sortBy=id&direction=desc&afterId=' + boundId);
    };

    getNextRequest = () => {
        const domain = this.messengerDomain;
        const list = this.state.list;
        const beforeId = list.length ? list[list.length - 1].id : 100000000;
        return JWTClient.fetch(domain + '/messages?limit=10&received=1&draft=0&sortBy=id&direction=desc&beforeId=' + beforeId);
    };
}


// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/messenger/message-infinite-scroll-list/index.js